export function emailsMatch(left: string | null | undefined, right: string | null | undefined): boolean {
    return left != null && right != null && left.toLowerCase() === right.toLowerCase();
}